export default {
    ITERATIONS: {
        // done
        ITERATION_1: [
            { len: 70, price: 6393.19 },
            { len: 140, price: 6330.01 },
            { len: 210, price: 6266.83 },
            { len: 280, price: 6203.66 },
            { len: 350, price: 6140.48 },
            { len: 420, price: 6077.30 },
            { len: 490, price: 6014.12 },
            { len: 560, price: 5950.94 },
            { len: 630, price: 5887.76 },
            { len: 700, price: 5824.58 },
            { len: 770, price: 5761.41 },
            { len: 840, price: 5698.23 },
            { len: 910, price: 5635.05 },
            { len: 980, price: 5571.87 },
            { len: 1050, price: 5508.69 },
            { len: 1120, price: 5445.51 },
            { len: 1190, price: 5382.34 },
            { len: 1260, price: 5319.16 },
            { len: 1330, price: 5255.98 },
            { len: 1400, price: 5192.80 },
            { len: 1470, price: 5129.62 },
            { len: 1540, price: 4971.76 }

        ],
        // done
        ITERATION_2: [
            { len: 70, price: 6393.19 },
            { len: 140, price: 6330.01 },
            { len: 210, price: 6266.83 },
            { len: 280, price: 6203.66 },
            { len: 350, price: 6140.48 },
            { len: 420, price: 6077.30 },
            { len: 490, price: 6014.12 },
            { len: 560, price: 5950.94 },
            { len: 630, price: 5887.76 },
            { len: 700, price: 5824.58 },
            { len: 770, price: 5761.41 },
            { len: 840, price: 5698.23 },
            { len: 910, price: 5635.05 },
            { len: 980, price: 5571.87 },
            { len: 1050, price: 5508.69 },
            { len: 1120, price: 5445.51 },
            { len: 1190, price: 5382.34 },
            { len: 1260, price: 5319.16 },
            { len: 1330, price: 5255.98 },
            { len: 1400, price: 5192.80 },
            { len: 1470, price: 5129.62 },
            { len: 1540, price: 5005.36 }
        ],
        // done
        ITERATION_3: [
            { len: 70, price: 6444.10 },
            { len: 140, price: 6380.93 },
            { len: 210, price: 6317.75 },
            { len: 280, price: 6254.57 },
            { len: 350, price: 6191.39 },
            { len: 420, price: 6128.21 },
            { len: 490, price: 6065.03 },
            { len: 560, price: 6001.86 },
            { len: 630, price: 5938.68 },
            { len: 700, price: 5875.50 },
            { len: 770, price: 5812.32 },
            { len: 840, price: 5749.14 },
            { len: 910, price: 5685.96 },
            { len: 980, price: 5622.78 },
            { len: 1050, price: 5559.61 },
            { len: 1120, price: 5496.43 },
            { len: 1190, price: 5433.25 },
            { len: 1260, price: 5370.07 },
            { len: 1330, price: 5306.89 },
            { len: 1400, price: 5243.71 },
            { len: 1470, price: 5180.54 },
            { len: 1540, price: 5033.36 }
        ],
        // done
        ITERATION_4: [
            { len: 70, price: 6444.10 },
            { len: 140, price: 6380.93 },
            { len: 210, price: 6317.75 },
            { len: 280, price: 6254.57 },
            { len: 350, price: 6191.39 },
            { len: 420, price: 6128.21 },
            { len: 490, price: 6065.03 },
            { len: 560, price: 6001.86 },
            { len: 630, price: 5938.68 },
            { len: 700, price: 5875.50 },
            { len: 770, price: 5812.32 },
            { len: 840, price: 5749.14 },
            { len: 910, price: 5685.96 },
            { len: 980, price: 5622.78 },
            { len: 1050, price: 5559.61 },
            { len: 1120, price: 5496.43 },
            { len: 1190, price: 5433.25 },
            { len: 1260, price: 5370.07 },
            { len: 1330, price: 5306.89 },
            { len: 1400, price: 5243.71 },
            { len: 1470, price: 5180.54 },
            { len: 1540, price: 5117.36 }
        ],
        // done
        ITERATION_5: [
            { len: 70, price: 5893.16 },
            { len: 140, price: 5829.98 },
            { len: 210, price: 5766.80 },
            { len: 280, price: 5703.62 },
            { len: 350, price: 5640.44 },
            { len: 420, price: 5577.27 },
            { len: 490, price: 5514.09 },
            { len: 560, price: 5450.91 },
            { len: 630, price: 5387.73 },
            { len: 700, price: 5324.55 },
            { len: 770, price: 5261.37 },
            { len: 840, price: 5198.20 },
            { len: 910, price: 5135.02 },
            { len: 980, price: 5071.84 },
            { len: 1050, price: 5008.66 },
            { len: 1120, price: 4945.48 },
            { len: 1190, price: 4882.30 },
            { len: 1260, price: 4819.12 },
            { len: 1330, price: 4755.95 },
            { len: 1400, price: 4692.77 },
            { len: 1470, price: 4629.59 },
            { len: 1540, price: 4520.97 }
        ],
        // done
        ITERATION_6: [
            { len: 70, price: 6925.19 },
            { len: 140, price: 6862.01 },
            { len: 210, price: 6798.83 },
            { len: 280, price: 6735.66 },
            { len: 350, price: 6672.48 },
            { len: 420, price: 6609.30 },
            { len: 490, price: 6546.12 },
            { len: 560, price: 6482.94 },
            { len: 630, price: 6419.76 },
            { len: 700, price: 6356.58 },
            { len: 770, price: 6293.41 },
            { len: 840, price: 6230.23 },
            { len: 910, price: 6167.05 },
            { len: 980, price: 6103.87 },
            { len: 1050, price: 6040.69 },
            { len: 1120, price: 5977.51 },
            { len: 1190, price: 5914.34 },
            { len: 1260, price: 5851.16 },
            { len: 1330, price: 5787.98 },
            { len: 1400, price: 5724.80 },
            { len: 1470, price: 5661.62 },
            { len: 1540, price: 5458.66 }
        ],
        // done
        ITERATION_7: [
            { len: 70, price: 6953.19 },
            { len: 140, price: 6890.01 },
            { len: 210, price: 6826.83 },
            { len: 280, price: 6763.66 },
            { len: 350, price: 6700.48 },
            { len: 420, price: 6637.30 },
            { len: 490, price: 6574.12 },
            { len: 560, price: 6510.94 },
            { len: 630, price: 6447.76 },
            { len: 700, price: 6384.58 },
            { len: 770, price: 6321.41 },
            { len: 840, price: 6258.23 },
            { len: 910, price: 6195.05 },
            { len: 980, price: 6131.87 },
            { len: 1050, price: 6068.69 },
            { len: 1120, price: 6005.51 },
            { len: 1190, price: 5942.34 },
            { len: 1260, price: 5879.16 },
            { len: 1330, price: 5815.98 },
            { len: 1400, price: 5752.80 },
            { len: 1470, price: 5689.62 },
            { len: 1540, price: 5514.66 }
        ],
        // done
        ITERATION_8: [
            { len: 70, price: 7009.19 },
            { len: 140, price: 6946.01 },
            { len: 210, price: 6882.83 },
            { len: 280, price: 6819.66 },
            { len: 350, price: 6756.48 },
            { len: 420, price: 6693.30 },
            { len: 490, price: 6630.12 },
            { len: 560, price: 6566.94 },
            { len: 630, price: 6503.76 },
            { len: 700, price: 6440.58 },
            { len: 770, price: 6377.41 },
            { len: 840, price: 6314.23 },
            { len: 910, price: 6251.05 },
            { len: 980, price: 6187.87 },
            { len: 1050, price: 6124.69 },
            { len: 1120, price: 6061.51 },
            { len: 1190, price: 5998.34 },
            { len: 1260, price: 5935.16 },
            { len: 1330, price: 5871.98 },
            { len: 1400, price: 5808.80 },
            { len: 1470, price: 5745.62 },
            { len: 1540, price: 5514.66 }
        ],
        // done
        ITERATION_9: [
            { len: 70, price: 7065.19 },
            { len: 140, price: 7002.01 },
            { len: 210, price: 6938.83 },
            { len: 280, price: 6875.66 },
            { len: 350, price: 6812.48 },
            { len: 420, price: 6749.30 },
            { len: 490, price: 6686.12 },
            { len: 560, price: 6622.94 },
            { len: 630, price: 6559.76 },
            { len: 700, price: 6496.58 },
            { len: 770, price: 6433.41 },
            { len: 840, price: 6370.23 },
            { len: 910, price: 6307.05 },
            { len: 980, price: 6243.87 },
            { len: 1050, price: 6180.69 },
            { len: 1120, price: 6117.51 },
            { len: 1190, price: 6054.34 },
            { len: 1260, price: 5991.16 },
            { len: 1330, price: 5927.98 },
            { len: 1400, price: 5864.80 },
            { len: 1470, price: 5801.62 },
            { len: 1540, price: 5570.66 }
        ],
        // done
        ITERATION_10: [
            { len: 70, price: 6607.80 },
            { len: 140, price: 6536.63 },
            { len: 210, price: 6465.46 },
            { len: 280, price: 6394.29 },
            { len: 350, price: 6323.13 },
            { len: 420, price: 6251.96 },
            { len: 490, price: 6180.79 },
            { len: 560, price: 6109.62 },
            { len: 630, price: 6038.45 },
            { len: 700, price: 5967.29 },
            { len: 770, price: 5896.12 },
            { len: 840, price: 5824.95 },
            { len: 910, price: 5753.78 },
            { len: 980, price: 5682.61 },
            { len: 1050, price: 5611.45 },
            { len: 1120, price: 5540.28 },
            { len: 1190, price: 5469.11 },
            { len: 1260, price: 5397.94 },
            { len: 1330, price: 5326.78 },
            { len: 1400, price: 5255.61 },
            { len: 1470, price: 5184.44 },
            { len: 1540, price: 4525.67 }
        ],
        // done
        ITERATION_11: [
            { len: 70, price: 7751.51 },
            { len: 140, price: 7688.33 },
            { len: 210, price: 7625.15 },
            { len: 280, price: 7561.98 },
            { len: 350, price: 7498.80 },
            { len: 420, price: 7435.62 },
            { len: 490, price: 7372.44 },
            { len: 560, price: 7309.26 },
            { len: 630, price: 7246.08 },
            { len: 700, price: 7182.91 },
            { len: 770, price: 7119.73 },
            { len: 840, price: 7056.55 },
            { len: 910, price: 6993.37 },
            { len: 980, price: 6930.19 },
            { len: 1050, price: 6867.01 },
            { len: 1120, price: 6803.83 },
            { len: 1190, price: 6740.66 },
            { len: 1260, price: 6677.48 },
            { len: 1330, price: 6614.30 },
            { len: 1400, price: 6551.12 },
            { len: 1470, price: 6487.94 },
            { len: 1540, price: 6222.22 }
        ],
        // done
        ITERATION_12: [
            { len: 70, price: 7773.91 },
            { len: 140, price: 7710.73 },
            { len: 210, price: 7647.55 },
            { len: 280, price: 7584.38 },
            { len: 350, price: 7521.20 },
            { len: 420, price: 7458.02 },
            { len: 490, price: 7394.84 },
            { len: 560, price: 7331.66 },
            { len: 630, price: 7268.48 },
            { len: 700, price: 7205.31 },
            { len: 770, price: 7142.13 },
            { len: 840, price: 7078.95 },
            { len: 910, price: 7015.77 },
            { len: 980, price: 6952.59 },
            { len: 1050, price: 6889.41 },
            { len: 1120, price: 6826.23 },
            { len: 1190, price: 6763.06 },
            { len: 1260, price: 6699.88 },
            { len: 1330, price: 6636.70 },
            { len: 1400, price: 6573.52 },
            { len: 1470, price: 6510.34 },
            { len: 1540, price: 6250.22 }
        ],
        // done
        ITERATION_13: [
            { len: 70, price: 7801.91 },
            { len: 140, price: 7738.73 },
            { len: 210, price: 7675.55 },
            { len: 280, price: 7612.38 },
            { len: 350, price: 7549.20 },
            { len: 420, price: 7486.02 },
            { len: 490, price: 7422.84 },
            { len: 560, price: 7359.66 },
            { len: 630, price: 7296.48 },
            { len: 700, price: 7233.31 },
            { len: 770, price: 7170.13 },
            { len: 840, price: 7106.95 },
            { len: 910, price: 7043.77 },
            { len: 980, price: 6980.59 },
            { len: 1050, price: 6917.41 },
            { len: 1120, price: 6854.23 },
            { len: 1190, price: 6791.06 },
            { len: 1260, price: 6727.88 },
            { len: 1330, price: 6664.70 },
            { len: 1400, price: 6601.52 },
            { len: 1470, price: 6538.34 },
            { len: 1540, price: 6278.22 }
        ],
        // done
        ITERATION_14: [
            { len: 70, price: 7885.91 },
            { len: 140, price: 7822.73 },
            { len: 210, price: 7759.55 },
            { len: 280, price: 7696.38 },
            { len: 350, price: 7633.20 },
            { len: 420, price: 7570.02 },
            { len: 490, price: 7506.84 },
            { len: 560, price: 7443.66 },
            { len: 630, price: 7380.48 },
            { len: 700, price: 7317.31 },
            { len: 770, price: 7254.13 },
            { len: 840, price: 7190.95 },
            { len: 910, price: 7127.77 },
            { len: 980, price: 7064.59 },
            { len: 1050, price: 7001.41 },
            { len: 1120, price: 6938.23 },
            { len: 1190, price: 6875.06 },
            { len: 1260, price: 6811.88 },
            { len: 1330, price: 6748.70 },
            { len: 1400, price: 6685.52 },
            { len: 1470, price: 6622.34 },
            { len: 1540, price: 6334.22 }
        ],
        // done
        ITERATION_15: [
            { len: 70, price: 7503.80 },
            { len: 140, price: 7429.91 },
            { len: 210, price: 7356.02 },
            { len: 280, price: 7282.13 },
            { len: 350, price: 7208.24 },
            { len: 420, price: 7134.35 },
            { len: 490, price: 7060.46 },
            { len: 560, price: 6986.57 },
            { len: 630, price: 6912.68 },
            { len: 700, price: 6838.79 },
            { len: 770, price: 6764.90 },
            { len: 840, price: 6691.01 },
            { len: 910, price: 6617.12 },
            { len: 980, price: 6543.23 },
            { len: 1050, price: 6469.34 },
            { len: 1120, price: 6395.45 },
            { len: 1190, price: 6321.56 },
            { len: 1260, price: 6247.67 },
            { len: 1330, price: 6173.78 },
            { len: 1400, price: 6099.89 },
            { len: 1470, price: 6026.00 },
            { len: 1540, price: 5407.03 }
        ],
        // done
        ITERATION_16: [
            { len: 70, price: 10274.72 },
            { len: 140, price: 10211.54 },
            { len: 210, price: 10148.36 },
            { len: 280, price: 10085.18 },
            { len: 350, price: 10022.00 },
            { len: 420, price: 9958.82 },
            { len: 490, price: 9895.65 },
            { len: 560, price: 9832.47 },
            { len: 630, price: 9769.29 },
            { len: 700, price: 9706.11 },
            { len: 770, price: 9642.93 },
            { len: 840, price: 9579.75 },
            { len: 910, price: 9516.57 },
            { len: 980, price: 9453.40 },
            { len: 1050, price: 9390.22 },
            { len: 1120, price: 9327.04 },
            { len: 1190, price: 9263.86 },
            { len: 1260, price: 9200.68 },
            { len: 1330, price: 9137.50 },
            { len: 1400, price: 9074.32 },
            { len: 1470, price: 9011.15 },
            { len: 1540, price: 8520.36 }
        ],
        // done
        ITERATION_17: [
            { len: 70, price: 10302.72 },
            { len: 140, price: 10239.54 },
            { len: 210, price: 10176.36 },
            { len: 280, price: 10113.18 },
            { len: 350, price: 10050.00 },
            { len: 420, price: 9986.82 },
            { len: 490, price: 9923.65 },
            { len: 560, price: 9860.47 },
            { len: 630, price: 9797.29 },
            { len: 700, price: 9734.11 },
            { len: 770, price: 9670.93 },
            { len: 840, price: 9607.75 },
            { len: 910, price: 9544.57 },
            { len: 980, price: 9481.40 },
            { len: 1050, price: 9418.22 },
            { len: 1120, price: 9355.04 },
            { len: 1190, price: 9291.86 },
            { len: 1260, price: 9228.68 },
            { len: 1330, price: 9165.50 },
            { len: 1400, price: 9102.32 },
            { len: 1470, price: 9039.15 },
            { len: 1540, price: 8542.76 }
        ],
        // done
        ITERATION_18: [
            { len: 70, price: 10330.72 },
            { len: 140, price: 10267.54 },
            { len: 210, price: 10204.36 },
            { len: 280, price: 10141.18 },
            { len: 350, price: 10078.00 },
            { len: 420, price: 10014.82 },
            { len: 490, price: 9951.65 },
            { len: 560, price: 9888.47 },
            { len: 630, price: 9825.29 },
            { len: 700, price: 9762.11 },
            { len: 770, price: 9698.93 },
            { len: 840, price: 9635.75 },
            { len: 910, price: 9572.57 },
            { len: 980, price: 9509.40 },
            { len: 1050, price: 9446.22 },
            { len: 1120, price: 9383.04 },
            { len: 1190, price: 9319.86 },
            { len: 1260, price: 9256.68 },
            { len: 1330, price: 9193.50 },
            { len: 1400, price: 9130.32 },
            { len: 1470, price: 9067.15 },
            { len: 1540, price: 8609.96 }
        ],
        // done
        ITERATION_19: [
            { len: 70, price: 10358.72 },
            { len: 140, price: 10295.54 },
            { len: 210, price: 10232.36 },
            { len: 280, price: 10169.18 },
            { len: 350, price: 10106.00 },
            { len: 420, price: 1042.82 },
            { len: 490, price: 9979.65 },
            { len: 560, price: 9916.47 },
            { len: 630, price: 9853.29 },
            { len: 700, price: 9790.11 },
            { len: 770, price: 9726.93 },
            { len: 840, price: 9663.75 },
            { len: 910, price: 9600.57 },
            { len: 980, price: 9537.40 },
            { len: 1050, price: 9474.22 },
            { len: 1120, price: 9411.04 },
            { len: 1190, price: 9347.86 },
            { len: 1260, price: 9284.68 },
            { len: 1330, price: 9221.50 },
            { len: 1400, price: 9158.32 },
            { len: 1470, price: 9095.15 },
            { len: 1540, price: 8710.76 }
        ],
// done
        ITERATION_20: [
            { len: 70, price: 9829.17 },
            { len: 140, price: 9750.69 },
            { len: 210, price: 9672.22 },
            { len: 280, price: 9593.75 },
            { len: 350, price: 9515.27 },
            { len: 420, price: 9436.80 },
            { len: 490, price: 9358.32 },
            { len: 560, price: 9279.85 },
            { len: 630, price: 9201.38 },
            { len: 700, price: 9122.90 },
            { len: 770, price: 9044.43 },
            { len: 840, price: 8965.96 },
            { len: 910, price: 8887.48 },
            { len: 980, price: 8809.01 },
            { len: 1050, price: 8730.53 },
            { len: 1120, price: 8652.06 },
            { len: 1190, price: 8573.59 },
            { len: 1260, price: 8495.11 },
            { len: 1330, price: 8416.64 },
            { len: 1400, price: 8338.16 },
            { len: 1470, price: 8259.69 },
            { len: 1540, price: 7705.12 }
        ],
    },
    ITERATION_MAP: {
        '1.75 meters ≅ (5\'9")': {
            'Angle Bar , 4 Strands': 'ITERATION_1',
            'Angle Bar , 5 Strands': 'ITERATION_2',
            'GI Pipe , 4 Strands': 'ITERATION_3',
            'GI Pipe , 5 Strands': 'ITERATION_4',
            None: 'ITERATION_5',
        },
        '2.1 meters ≅ (6\'10")': {
            'Angle Bar , 4 Strands': 'ITERATION_6',
            'Angle Bar , 5 Strands': 'ITERATION_7',
            'GI Pipe , 4 Strands': 'ITERATION_8',
            'GI Pipe , 5 Strands': 'ITERATION_9',
            None: 'ITERATION_10',
        },
        "2.45 meters ≅ (8')": {
            'Angle Bar , 4 Strands': 'ITERATION_11',
            'Angle Bar , 5 Strands': 'ITERATION_12',
            'GI Pipe , 4 Strands': 'ITERATION_13',
            'GI Pipe , 5 Strands': 'ITERATION_14',
            None: 'ITERATION_15',
        },
        '2.8 meters ≅ (9\'2")': {
            'Angle Bar , 4 Strands': 'ITERATION_16',
            'Angle Bar , 5 Strands': 'ITERATION_17',
            'GI Pipe , 4 Strands': 'ITERATION_18',
            'GI Pipe , 5 Strands': 'ITERATION_19',
            None: 'ITERATION_20',
        },
    }
};